import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EleicaoService } from 'src/app/services/eleicao.service';

@Component({
  selector: 'app-acesso-negado',
  templateUrl: './acesso-negado.component.html'
})
export class AcessoNegadoComponent implements OnInit {
  eleicaoRota: any;
  textoErro: any;
  logoEleicao: any;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private eleicaoService: EleicaoService
  ) {
  }

  ngOnInit() {
    var rotaEleicao = sessionStorage.getItem("rotaEleicao");
    this.textoErro = sessionStorage.getItem("textoErro");
    if(this.textoErro == undefined || this.textoErro == null || this.textoErro == "undefined"
    || this.textoErro == "null"){
    this.textoErro = "Não foi possível acessar. " +
      "Em caso de dúvidas, entre em contato com o suporte de sua entidade!";
    }
    var rotaEleicao = sessionStorage.getItem("rotaEleicao");
    sessionStorage.clear();
    this.getLogoEleicao(rotaEleicao);
    this.spinner.hide();
  }

  public atualizar() {
    location.reload();
  }

  async getLogoEleicao(rota: string) {
    try {
      const logo = await this.eleicaoService.getLogoByRotaEleicao(rota).toPromise();
      if (logo) {
        this.eleicaoService.logoEleicao = logo;
        sessionStorage.setItem('logoEleicao', logo);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
